import { Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Events } from '@type-r/models';
import { useChanges, useLinked } from '@type-r/react';
import { asDateTime, Link, PageTileField } from 'lqx-react';
import * as React from 'react';
import { CommunicationModel, globalStore } from '../../../../api';

const { communications } = globalStore;

export const Communications = () => {
    const classes = useStyles();
    useChanges(communications);

    const $anchorEl = useLinked(null),
        hasNotifications = Boolean(communications.filter(x => !x.read && x.isActive).length > 0);

    const list = communications.filter(x => !x.read).slice(0, 3);
    return <>
        <div
            className={classes.root}
            onMouseEnter={({ currentTarget }) => $anchorEl.set(currentTarget)}
            onMouseLeave={$anchorEl.null}
        >
            {hasNotifications ?
                <span className={classes.counter}>
                    {communications.filter(x => !x.read).length}
                </span> : null
            }
            <div className={'fa fa-bell ' + classes.icon} />

            <Popover
                open={Boolean($anchorEl.value)}
                anchorEl={$anchorEl.value}

                classes={{
                    paper: classes.menu
                }}

                onClose={$anchorEl.null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <div className={classes.caption}>
                    Notifications
                </div>

                <hr />

                {hasNotifications
                    ? 
                    <>
                        {list.map(x => <Notification key={x.cid} model={x} onClick={() => Events.trigger('navigate', x.createUrl())} />)}
                    </>
                    : <></>}

                <Link style={{ textDecoration: 'none' }} href="/communications" onClick={$anchorEl.null}>
                    View all notifications
                </Link>
            </Popover>
        </div>
    </>
}

const useStyles = makeStyles({
    root: {

    },

    caption: {
        textTransform: "uppercase",
        fontSize: '14px'
    },

    menu: {
        width: 240,
        padding: 10,

    },

    counter: {
        padding: '3px 6px 3px 6px',
        borderRadius: 3,
        backgroundColor: '#F5B632'
    },

    icon: {
        fontSize: '18px',
        color: '#9FA7B1',
        padding: 4
    },

    link: {
        fontSize: '14px',
    }
})

const Notification = ({ model, onClick }: {
    model: CommunicationModel,
    onClick: Function
}) => {
    return (
        <Link style={{ textDecoration: 'none' }} 
            onClick={ async () => {
                model.read = true;
                await model.save();
                onClick();
            }}
        >
            <PageTileField label={asDateTime(model.createdOn)}>
                {model.subject}
            </PageTileField>
            <hr />
        </Link>
    )
}